import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./i18n";
import "./index.css";

// A dynamically-imported chunk failed to preload — almost always a stale chunk
// right after a deploy. Do ONE guarded reload to pull the fresh build instead of
// leaving the user on a white screen. (Vite fires this event for module preloads;
// lazyRetry handles the same for the actual import() call.)
window.addEventListener("vite:preloadError", () => {
  try {
    const KEY = "step_preload_reload_ts";
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last > 12_000) {
      sessionStorage.setItem(KEY, String(Date.now()));
      window.location.reload();
    }
  } catch {
    /* sessionStorage unavailable — skip */
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
